var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1669971372159,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4471,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.855 894h-675.71C80.906 894 62 875.159 62 852V364c0-23.159 18.906-42 42.145-42h675.71C803.094 322 822 340.841 822 364v488c0 23.159-18.906 42-42.145 42zM112 844h660V372H112v472z",
    "p-id": 4472
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M894 731H781v-50h105V209H232v139h-50V201c0-23.159 18.841-42 42-42h670c23.159 0 42 18.841 42 42v488c0 23.159-18.841 42-42 42z",
    "p-id": 4473
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.095a0152.svg";
export { ForwardRef as ReactComponent };